import { Button } from "@mui/material";
import { getLocalStorage } from "../../stores/localStores";
import { Google } from "@mui/icons-material";
export const LoginGoogleButton = () => {
  return (
    <Button
      onClick={() => {
        const url = new URL(`${process.env.REACT_APP_API_ESTAGE}/auth/google`);
        url.searchParams.set("app", "estate"); // ?foo=1&q=zap
        if (!!getLocalStorage("sponsor")) {
          url.searchParams.set("sponsor", getLocalStorage("sponsor"));
        }

        window.location.href = url.toString();
      }}
      variant="contained"
      startIcon={<Google />}
      size="large"
      sx={{
        backgroundColor: "#a95052",
        "&:hover": { backgroundColor: "#8c3e47" },
        width: "100%",
      }}
    >
      Cuenta de Google
    </Button>
  );
};
